// extracted by mini-css-extract-plugin
module.exports = {"testimonialWrapper":"Testimonial_testimonialWrapper__m31MO","testimonial":"Testimonial_testimonial__ws6J4","dark":"Testimonial_dark__uGOiT","quote":"Testimonial_quote__qoHJb"};